import { render, staticRenderFns } from "./MapItemSetup.vue?vue&type=template&id=4f415d36&scoped=true"
import script from "./MapItemSetup.vue?vue&type=script&lang=ts"
export * from "./MapItemSetup.vue?vue&type=script&lang=ts"
import style0 from "./MapItemSetup.vue?vue&type=style&index=0&id=4f415d36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f415d36",
  null
  
)

export default component.exports